import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
    Visibility,
    Add
} from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    adderCategoriesReset,
    DeleteAddreCategoryMethod,
    GetAllAddersCategories,
} from "../../Redux/AddersCategoriesSlice/AddersCategoriesSlice";
// import AdderStatusConfirm from "./AdderStatusConfirm";
import GroupChildrens from "./GroupChildrens";
import CreateGroupChildren from "./CreateGroupChildren";

const AllAddersCategories = () => {
    const dispatch = useDispatch();
    // Pop Up Data
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    //edit row
    const [childrens, setChildrens] = useState(false);
    const [add_children, setAddChildrens] = useState(false);
    const handelOpenGroupChildrens = (data) => {
        setData(data);
        setChildrens(true);
    };
    const handelCloseGroupChildrens = () => {
        setData({});
        setChildrens(false);
    };
    const handelAddChildrens = (data) => {
        setData(data);
        setAddChildrens(true);
    };
    const handelCloseAddChildrens = () => {
        setData({});
        setAddChildrens(false);
    };

    // Delete Adder Confirm

    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success("Group deleted success");
        await GetAllAddersGroupsAction();
        await dispatch(adderCategoriesReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteAddreCategoryMethod(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteAdder = async (data) => {
        handleOpen(data);
    };

    const { adders_categories, isSuccess, isLoading, isError, errors } = useSelector(
        (state) => state.adders_categories
    );
    const AllAddersVal = adders_categories?.data || [];

    console.log(AllAddersVal)
    const GetAllAddersGroupsAction = async () => {
        await dispatch(
            GetAllAddersCategories({
                return_all: 1
            })
        );
    };
    useEffect(() => {
        GetAllAddersGroupsAction();
    }, []);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderCategoriesReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    // Change Adder Status

    const [status, setStatus] = useState(false);

    const handelOpenStatusRow = (data) => {
        setData(data);
        setStatus(true);
    };

    const handelCloseStatusRow = () => {
        setData({});
        setStatus(false);
    };

    useEffect(() => {
        // console.log(isSuccess);
    }, [isSuccess]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell> Adder Name</TableCell>
                                <TableCell> Type </TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {AllAddersVal?.map((key, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>
                                        {index + 1}
                                        {/* {rowsPerPage * page + index + 1} */}
                                    </TableCellStyle>
                                    <TableCellStyle>{key?.name}</TableCellStyle>
                                    <TableCellStyle>{key?.type}</TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton>
                                            <Link to={"edit-group=" + key.id}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton onClick={(e) => handelOpenGroupChildrens(key)}>
                                            <Link to={"group_childrens/"+key?.id}>
                                                <Visibility />
                                            </Link>
                                        </IconButton>
                                        <IconButton onClick={(e) => handelAddChildrens(key)}>
                                            <Link to={"#"}>
                                                <Add />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={(e) =>
                                                handelDeleteAdder(key)
                                            }
                                        >
                                            <Link to={"#"}>
                                                <Delete color="error" />
                                            </Link>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>

                    {/* Show Group Childrens MODAL  */}
                    <PopupModal open={childrens} close={handelCloseGroupChildrens}>
                        <GroupChildrens group_id={data?.id} />
                    </PopupModal>
                    
                    {/* Add Childrens To Group MODAL  */}
                    <PopupModal open={add_children} close={handelCloseAddChildrens}>
                        <CreateGroupChildren group_id={data?.id} />
                    </PopupModal>

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllAddersCategories;
